<template>
  <div>
    <v-select
      :name="name"
      label="value"
      :value="parameter"
      :options="parameterList"
      @input="update"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'VNFRProductFormsParameter',
  props: {
    name: {
      type: String,
      required: true
    },
    parameter: {
      type: Object,
      required: true
    },
    parameterList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    update( event ) {
      if ( event !== null ) {
        this.parameter.id = event.id
        this.parameter.parameter_type_id = event.parameter_type_id
        this.parameter.value = event.value
      } else {
        this.parameter.id = null
        this.parameter.value = ''
      }
    }
  }
}
</script>
